import React from 'react';
import styled from 'styled-components';

interface BlockWithVisibleProps {
  width: string;
  isColumn?: boolean;
  value: string;
  isHover?: boolean;
  isActive?: boolean;
}

const AdminBlockWithVisible: React.FC<BlockWithVisibleProps> = ({
  width,
  isColumn,
  value,
  isHover,
  isActive,
}) => (
  <Block
    $width={width}
    $isColumn={isColumn}
    $isHover={isHover}
    $isActive={isActive}
  >
    <Value $isColumn={isColumn}>
      {value}
    </Value>
  </Block>
);

const Block = styled.div<{
  $width: string;
  $isColumn: boolean | undefined;
  $isHover: boolean | undefined;
  $isActive: boolean | undefined;
}>`
  flex: ${({ $width }) => $width};

  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 0;

  border-bottom: ${({ $isColumn, theme }) =>
    $isColumn ? 'none' : `0.5px solid ${theme.colors.color_Gray_04}`};
  cursor: ${({ $isHover }) => $isHover ? 'pointer' : 'default'};

  background-color: ${({ theme, $isHover, $isActive }) =>
    $isActive
      ? theme.colors.color_Gray_06
      : $isHover
        ? theme.colors.color_Gray_07
        : 'transparent'};
`;

const Value = styled.span<{ $isColumn: boolean | undefined }>`
  width: 80%;

  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;

  padding-left: ${({ $isColumn }) => $isColumn ? '0px' : '3px'};

  text-align: center;
`;

export default AdminBlockWithVisible;
